import { authenticatedFetch } from "../utils/api";
import { API_HOST } from "../utils/constants";

const jobPath = (jobId) => `${API_HOST}/api/video-repaint/jobs/${encodeURIComponent(jobId)}`;
const engGuaVideoAssetPath = `${API_HOST}/api/resource/dreamina-proxy-asset`;

export const listVideoRepaintJobs = (projectId) => (
  authenticatedFetch(`${API_HOST}/api/video-repaint/jobs?projectId=${encodeURIComponent(projectId)}`)
);

export const getVideoRepaintJob = (jobId) => authenticatedFetch(jobPath(jobId));

export const reanalyzeVideoRepaint = (jobId) => (
  authenticatedFetch(`${jobPath(jobId)}/reanalyze`, { method: "POST" })
);

export const analyzeVideoRepaint = ({
  file,
  projectId,
  provider,
  analysisMode = "hybrid",
  transcript = "",
}) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("projectId", String(projectId));
  formData.append("analysisMode", analysisMode);
  if (provider) formData.append("provider", provider);
  if (transcript.trim()) formData.append("transcript", transcript.trim());
  return authenticatedFetch(`${API_HOST}/api/video-repaint/analyze`, {
    method: "POST",
    body: formData,
    timeout: 600000,
  });
};

export const updateVideoRepaintMappings = (jobId, payload) => (
  authenticatedFetch(`${jobPath(jobId)}/mappings`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  })
);

export const updateVideoRepaintShot = (jobId, shotId, payload) => (
  authenticatedFetch(`${jobPath(jobId)}/shots/${encodeURIComponent(shotId)}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  })
);

export const updateVideoRepaintReview = (jobId, payload) => (
  authenticatedFetch(`${jobPath(jobId)}/review`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  })
);

export const generateVideoRepaintShot = (jobId, shotId) => (
  authenticatedFetch(`${jobPath(jobId)}/shots/${encodeURIComponent(shotId)}/generate`, {
    method: "POST",
  })
);

export const generateAllVideoRepaintShots = (jobId) => (
  authenticatedFetch(`${jobPath(jobId)}/generate-all`, { method: "POST" })
);

export const createVideoRepaintKeyframeAsset = ({ projectId, url, name }) => (
  authenticatedFetch(`${engGuaVideoAssetPath}/create`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      projectId: projectId ? Number(projectId) : undefined,
      url,
      name,
      assetType: "Image",
      typeCode: "storyboard_image",
      source: "video_repaint",
      sourceDetail: "video_repaint_keyframe",
    }),
  })
);

export const getVideoRepaintKeyframeAssetStatus = ({ projectId, url, assetId }) => (
  authenticatedFetch(`${engGuaVideoAssetPath}/status`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      projectId: projectId ? Number(projectId) : undefined,
      url,
      assetId,
    }),
  })
);
